import React from 'react';
import { Trophy } from 'lucide-react';
import type { UserTrophy } from '../../types/trophy';

interface TrophyListProps {
  trophies: UserTrophy[];
}

const TrophyList: React.FC<TrophyListProps> = ({ trophies }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {trophies.map((trophy) => (
        <div
          key={trophy.id}
          className="bg-background p-4 rounded-lg border border-gray-800 flex items-center gap-4"
        >
          <div className="p-2 bg-brand/10 rounded-lg">
            <Trophy className="w-6 h-6 text-brand" />
          </div>
          <div>
            <h3 className="font-semibold text-content-primary">
              {trophy.title}
            </h3>
            <p className="text-sm text-content-secondary">
              {trophy.description}
            </p>
            <p className="text-xs text-content-secondary mt-1">
              Earned {new Date(trophy.created_at).toLocaleDateString()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrophyList;